import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-h2-icon',
  templateUrl: './text-h2.component.html'
})
export class TextH2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
